import * as React from 'react';
import { alpha, styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { alpha, styled }, "@mui/material/InputBase": InputBase, "@mui/material/Box": Box, "@mui/material/InputLabel": InputLabel, "@mui/material/TextField": TextField, "@mui/material/FormControl": FormControl } } });
export default ClientProvider;
